module.exports = __webpack_public_path__ + "img/mastercardblack.fc70d87a.svg";